// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // 12px
  xs: '0.75rem',
  // 14px
  sm: '0.875rem',
  // 16px
  md: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  '2xl': '1.5rem',
  '3xl': '1.875rem',
  '4xl': '2.25rem',
  '5xl': '3rem',
  '6xl': '3.75rem',
  '7xl': '4.5rem',
  '8xl': '6rem',
  '9xl': '8rem',
}
